// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { get_users } from "../../store/services/authentication";
// import { FaRegEye, FaTrashAlt ,FaTimes} from "react-icons/fa";
// import { asyncStatus } from "../../utils/contants/asyncStatus";

// const UserManagment = () => {
//   const dispatch = useDispatch();
//   const { get_users_data, get_users_status } = useSelector(
//     (state) => state.userAuth
//   );
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const handleView = (user) => {
//     setSelectedUser(user);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedUser(null);
//   };

//   useEffect(() => {
//     dispatch(get_users());
//   }, [dispatch]);

//   const handleDelete = (userId) => {
//     if (window.confirm("Are you sure you want to delete this user?")) {
//       console.log("Deleting user with ID:", userId);
//     }
//   };

// //   const handleView = (user) => {
// //     console.log("Viewing user:", user);
// //   };

//   console.log("get_users_data",get_users_data?.users)
//   console.log("get_users_data",get_users_status)

//   if (get_users_status === asyncStatus.LOADING) {
//     return <div className="text-center py-8 text-black">Loading users...</div>;
//   }

//   if (get_users_status === asyncStatus.ERROR) {
//     return <div className="text-center py-8 text-red-500">Error loading users</div>;
//   }

//   return (
//     <div className="container mx-auto px-4 py-8">
//       <h1 className="text-2xl font-bold mb-6 text-gray-800">User Management</h1>
//       {isModalOpen && selectedUser && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
//             {/* Modal Header */}
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-semibold text-black">
//                 {selectedUser.first_name}'s Profile
//               </h2>
//               <button
//                 onClick={closeModal}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <FaTimes className="h-6 w-6" />
//               </button>
//             </div>

//             {/* Modal Content */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               {/* Left Column */}
//               <div className="space-y-4">
//                 <div className="flex items-center space-x-4">
//                   <img
//                     className="h-24 w-24 rounded-full"
//                     src={selectedUser.avatar}
//                     alt="User avatar"
//                   />
//                   <div>
//                     <h3 className="text-lg font-semibold text-black">
//                       {selectedUser.first_name} {selectedUser.last_name}
//                     </h3>
//                     <p className="text-gray-600">{selectedUser.email}</p>
//                     <p className="text-gray-600">{selectedUser.phonenumber}</p>
//                   </div>
//                 </div>

//                 <div>
//                   <h4 className="font-medium mb-2 text-black">Basic Information</h4>
//                   <dl className="grid grid-cols-2 gap-2">
//                     <div>
//                       <dt className="text-sm text-gray-500">Gender</dt>
//                       <dd className="text-sm text-gray-500">{selectedUser.gender || 'N/A'}</dd>
//                     </div>
//                     <div>
//                       <dt className="text-sm text-gray-500">Zodiac</dt>
//                       <dd className="text-sm text-gray-500">{selectedUser.zodiac || 'N/A'}</dd>
//                     </div>
//                     <div>
//                       <dt className="text-sm text-gray-500">Education</dt>
//                       <dd className="text-sm text-gray-500">{selectedUser.education || 'N/A'}</dd>
//                     </div>
//                     <div>
//                       <dt className="text-sm text-gray-500">Family Plans</dt>
//                       <dd className="text-sm text-gray-500">{selectedUser.familyPlans || 'N/A'}</dd>
//                     </div>
//                   </dl>
//                 </div>
//               </div>

//               {/* Right Column */}
//               <div className="space-y-4">
//                 <div>
//                   <h4 className="font-medium mb-2 text-black">Location</h4>
//                   <p className="text-sm text-gray-500">
//                     {selectedUser.city}<br />
//                     Coordinates: {selectedUser.lattitude}, {selectedUser.longitude}
//                   </p>
//                 </div>

//                 <div>
//                   <h4 className="font-medium mb-2 text-black">Bio</h4>
//                   <p className="text-sm whitespace-pre-line text-gray-500">
//                     {selectedUser.bio || 'No bio available'}
//                   </p>
//                 </div>

//                 <div>
//                   <h4 className="font-medium mb-2 text-black">Preferences</h4>
//                   <dl className="grid grid-cols-2 gap-2">
//                     <div>
//                       <dt className="text-sm text-gray-500">Interested In</dt>
//                       <dd className="text-sm text-gray-500">{selectedUser.interest_in || 'N/A'}</dd>
//                     </div>
//                     <div>
//                       <dt className="text-sm text-gray-500">Relationship Goals</dt>
//                       <dd className="text-sm text-gray-500">{selectedUser.relationshipGoals || 'N/A'}</dd>
//                     </div>
//                   </dl>
//                 </div>
//               </div>
//             </div>

//             {/* Dates Section */}
//             <div className="mt-4 pt-4 border-t border-gray-200">
//               <div className="flex justify-between text-sm text-gray-500">
//                 <div>Created: {new Date(selectedUser.createdAt).toLocaleDateString()}</div>
//                 <div>Updated: {new Date(selectedUser.updatedAt).toLocaleDateString()}</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <div className="bg-white rounded-lg shadow overflow-hidden">
//         <table className="min-w-full divide-y divide-gray-200">
//           {/* Table Head remains same */}
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Name
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Email
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Location
//               </th>
//               {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Plan
//               </th> */}
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Verified
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {/* Remove .users from get_users_data */}
//             {get_users_data?.users?.map((user) => (
//               <tr key={user._id}>
//                 {/* Table Row contents remain same */}
//                 <td className="px-6 py-4 whitespace-nowrap">
//                   <div className="flex items-center">
//                     <div className="flex-shrink-0 h-10 w-10">
//                       <img
//                         className="h-10 w-10 rounded-full"
//                         src={user.avatar}
//                         alt={`${user.first_name}'s avatar`}
//                       />
//                     </div>
//                     <div className="ml-4">
//                       <div className="text-sm font-medium text-gray-900">
//                         {user.first_name} {user.last_name}
//                       </div>
//                     </div>
//                   </div>
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                   {user.email}
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                   {user.city}
//                 </td>
//                 {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                   <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
//                     {user.plan}
//                   </span>
//                 </td> */}
//                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                   {user.verified ? (
//                     <span className="text-green-500">✓</span>
//                   ) : (
//                     <span className="text-red-500">✕</span>
//                   )}
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                   <button
//                     onClick={() => handleView(user)}
//                     className="text-indigo-600 hover:text-indigo-900 mr-4"
//                     aria-label="View user"
//                   >
//                     <FaRegEye className="inline-block" />
//                   </button>
//                   <button
//                     onClick={() => handleDelete(user._id)}
//                     className="text-red-600 hover:text-red-900"
//                     aria-label="Delete user"
//                   >
//                     <FaTrashAlt className="inline-block" />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {/* Update condition here */}
//         {get_users_status === asyncStatus.SUCCEEDED && !get_users_data?.length && (
//           <div className="text-center py-4 text-gray-500">
//             No users found
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default UserManagment;

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   get_users,
//   update_user,
//   add_user,
//   delete_user,
// } from "../../store/services/authentication";
// import { FaRegEye, FaTrashAlt, FaTimes, FaPlus, FaEdit } from "react-icons/fa";
// import { asyncStatus } from "../../utils/contants/asyncStatus";

// const UserManagment = () => {
//   const dispatch = useDispatch();
//   const {
//     get_users_data,
//     get_users_status,
//     add_user_status,
//     add_user_error,
//     update_user_status,
//     delete_user_status,
//   } = useSelector((state) => state.userAuth);

//   const [selectedUser, setSelectedUser] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [isFormModalOpen, setIsFormModalOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     phonenumber: "",
//     gender: "Men",
//     verified: false,
//   });

//   useEffect(() => {
//     dispatch(get_users());
//     if (update_user_status || add_user_status === asyncStatus.SUCCEEDED) {
//       setIsFormModalOpen(false);
//       setIsEditMode(false);
//     }
//   }, [dispatch, add_user_status, update_user_status, delete_user_status]);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   const handleAddUser = () => {
//     setIsFormModalOpen(true);

//     setFormData({
//       first_name: "",
//       last_name: "",
//       email: "",
//       phonenumber: "",
//       gender: "Men",
//       verified: false,
//       role: "User",
//     });
//   };

//   const handleEdit = (user) => {
//     setSelectedUser(user);
//     setIsEditMode(true);
//     setIsFormModalOpen(true);
//     setFormData({
//       first_name: user.first_name,
//       last_name: user.last_name,
//       email: user.email,
//       phonenumber: user.phonenumber,
//       gender: user.gender,
//       verified: user.verified,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (isEditMode) {
//       dispatch(
//         update_user({
//           id: selectedUser._id,
//           ...formData,
//         })
//       );
//     } else {
//       dispatch(add_user(formData));
//     }
//   };

//   const handleDelete = (userId) => {
//     if (window.confirm("Are you sure you want to delete this user?")) {
//       dispatch(delete_user(userId));
//     }
//   };

//   const handleView = (user) => {
//     setSelectedUser(user);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedUser(null);
//   };

//   if (get_users_status === asyncStatus.LOADING) {
//     return <div className="text-center py-8 text-black">Loading users...</div>;
//   }

//   if (get_users_status === asyncStatus.ERROR) {
//     return (
//       <div className="text-center py-8 text-red-500">Error loading users</div>
//     );
//   }

//   console.log("add_user_error", add_user_error);

//   return (
//     <div className="container mx-auto px-4 py-8">
//       <div className="flex justify-between items-center mb-6">
//         <h1 className="text-2xl font-bold text-gray-800">User Management</h1>
//         <button
//           onClick={handleAddUser}
//           className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
//         >
//           <FaPlus className="inline-block" />
//           Add User
//         </button>
//       </div>

//       {/* Add/Edit User Modal */}
//       {isFormModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-semibold text-black">
//                 {isEditMode ? "Edit User" : "Add New User"}
//               </h2>
//               <button
//                 onClick={() => setIsFormModalOpen(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <FaTimes className="h-6 w-6" />
//               </button>
//             </div>

//             {add_user_error && (
//               <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg text-sm">
//                 {add_user_error?.message}
//               </div>
//             )}
//             <form onSubmit={handleSubmit}>
//               <div className="space-y-4">
//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       First Name *
//                     </label>
//                     <input
//                       type="text"
//                       name="first_name"
//                       value={formData.first_name}
//                       onChange={handleInputChange}
//                       className="w-full px-3 py-2 border rounded-lg"
//                       required
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Last Name *
//                     </label>
//                     <input
//                       type="text"
//                       name="last_name"
//                       value={formData.last_name}
//                       onChange={handleInputChange}
//                       className="w-full px-3 py-2 border rounded-lg"
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Email *
//                   </label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     className="w-full px-3 py-2 border rounded-lg"
//                     required
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Phone Number
//                   </label>
//                   <input
//                     type="tel"
//                     name="phonenumber"
//                     value={formData.phonenumber}
//                     onChange={handleInputChange}
//                     className="w-full px-3 py-2 border rounded-lg"
//                   />
//                 </div>
//                 {!isEditMode && (
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Password
//                     </label>
//                     <input
//                       type="password"
//                       name="password"
//                       value={formData.password}
//                       onChange={handleInputChange}
//                       className="w-full px-3 py-2 border rounded-lg"
//                     />
//                   </div>
//                 )}

//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Gender
//                     </label>
//                     <select
//                       name="gender"
//                       value={formData.gender}
//                       onChange={handleInputChange}
//                       className="w-full px-3 py-2 border rounded-lg"
//                     >
//                       <option value="Men">Men</option>
//                       <option value="Women">Women</option>
//                       <option value="other">Other</option>
//                     </select>
//                   </div>
//                   <div>
//                     <label className="flex items-center space-x-2 mt-6">
//                       <input
//                         type="checkbox"
//                         name="verified"
//                         checked={formData.verified}
//                         onChange={handleInputChange}
//                         className="form-checkbox"
//                       />
//                       <span className="text-sm text-gray-700">Verified</span>
//                     </label>
//                   </div>
//                 </div>

//                 <div className="mt-6">
//                   <button
//                     type="submit"
//                     className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700"
//                   >
//                     {isEditMode ? "Update User" : "Add User"}
//                   </button>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* View User Modal */}
//       {isModalOpen && selectedUser && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-semibold text-black">
//                 {selectedUser.first_name}'s Profile
//               </h2>
//               <button
//                 onClick={closeModal}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <FaTimes className="h-6 w-6" />
//               </button>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div className="space-y-4">
//                 <div className="flex items-center space-x-4">
//                   <img
//                     className="h-24 w-24 rounded-full"
//                     src={selectedUser.avatar}
//                     alt="User avatar"
//                   />
//                   <div>
//                     <h3 className="text-lg font-semibold text-black">
//                       {selectedUser.first_name} {selectedUser.last_name}
//                     </h3>
//                     <p className="text-gray-600">{selectedUser.email}</p>
//                     <p className="text-gray-600">{selectedUser.phonenumber}</p>
//                   </div>
//                 </div>

//                 <div>
//                   <h4 className="font-medium mb-2 text-black">
//                     Basic Information
//                   </h4>
//                   <dl className="grid grid-cols-2 gap-2">
//                     <div>
//                       <dt className="text-sm text-gray-500">Gender</dt>
//                       <dd className="text-sm text-gray-500">
//                         {selectedUser.gender || "N/A"}
//                       </dd>
//                     </div>
//                     <div>
//                       <dt className="text-sm text-gray-500">Zodiac</dt>
//                       <dd className="text-sm text-gray-500">
//                         {selectedUser.zodiac || "N/A"}
//                       </dd>
//                     </div>
//                     <div>
//                       <dt className="text-sm text-gray-500">Education</dt>
//                       <dd className="text-sm text-gray-500">
//                         {selectedUser.education || "N/A"}
//                       </dd>
//                     </div>
//                     <div>
//                       <dt className="text-sm text-gray-500">Family Plans</dt>
//                       <dd className="text-sm text-gray-500">
//                         {selectedUser.familyPlans || "N/A"}
//                       </dd>
//                     </div>
//                   </dl>
//                 </div>
//               </div>

//               <div className="space-y-4">
//                 <div>
//                   <h4 className="font-medium mb-2 text-black">Location</h4>
//                   <p className="text-sm text-gray-500">
//                     {selectedUser.city}
//                     <br />
//                     Coordinates: {selectedUser.lattitude},{" "}
//                     {selectedUser.longitude}
//                   </p>
//                 </div>

//                 <div>
//                   <h4 className="font-medium mb-2 text-black">Bio</h4>
//                   <p className="text-sm whitespace-pre-line text-gray-500">
//                     {selectedUser.bio || "No bio available"}
//                   </p>
//                 </div>

//                 <div>
//                   <h4 className="font-medium mb-2 text-black">Preferences</h4>
//                   <dl className="grid grid-cols-2 gap-2">
//                     <div>
//                       <dt className="text-sm text-gray-500">Interested In</dt>
//                       <dd className="text-sm text-gray-500">
//                         {selectedUser.interest_in || "N/A"}
//                       </dd>
//                     </div>
//                     <div>
//                       <dt className="text-sm text-gray-500">
//                         Relationship Goals
//                       </dt>
//                       <dd className="text-sm text-gray-500">
//                         {selectedUser.relationshipGoals || "N/A"}
//                       </dd>
//                     </div>
//                   </dl>
//                 </div>
//               </div>
//             </div>

//             <div className="mt-4 pt-4 border-t border-gray-200">
//               <div className="flex justify-between text-sm text-gray-500">
//                 <div>
//                   Created:{" "}
//                   {new Date(selectedUser.createdAt).toLocaleDateString()}
//                 </div>
//                 <div>
//                   Updated:{" "}
//                   {new Date(selectedUser.updatedAt).toLocaleDateString()}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Users Table */}
//       <div className="bg-white rounded-lg shadow overflow-hidden">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Name
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Email
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Location
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Verified
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {get_users_data?.users?.map((user) => (
//               <tr key={user._id}>
//                 <td className="px-6 py-4 whitespace-nowrap">
//                   <div className="flex items-center">
//                     <div className="flex-shrink-0 h-10 w-10">
//                       <img
//                         className="h-10 w-10 rounded-full"
//                         src={user.avatar}
//                         alt={`${user.first_name}'s avatar`}
//                       />
//                     </div>
//                     <div className="ml-4">
//                       <div className="text-sm font-medium text-gray-900">
//                         {user.first_name} {user.last_name}
//                       </div>
//                     </div>
//                   </div>
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                   {user.email}
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                   {user.city}
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                   {user.verified ? (
//                     <span className="text-green-500">✓</span>
//                   ) : (
//                     <span className="text-red-500">✕</span>
//                   )}
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                   <button
//                     onClick={() => handleEdit(user)}
//                     className="text-yellow-600 hover:text-yellow-800 mr-4"
//                     aria-label="Edit user"
//                   >
//                     <FaEdit className="inline-block" />
//                   </button>
//                   <button
//                     onClick={() => handleView(user)}
//                     className="text-indigo-600 hover:text-indigo-900 mr-4"
//                     aria-label="View user"
//                   >
//                     <FaRegEye className="inline-block" />
//                   </button>
//                   <button
//                     onClick={() => handleDelete(user._id)}
//                     className="text-red-600 hover:text-red-900"
//                     aria-label="Delete user"
//                   >
//                     <FaTrashAlt className="inline-block" />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {get_users_status === asyncStatus.SUCCEEDED &&
//           !get_users_data?.users?.length && (
//             <div className="text-center py-4 text-gray-500">No users found</div>
//           )}
//       </div>
//     </div>
//   );
// };

// export default UserManagment;

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  get_users,
  update_user,
  add_user,
  delete_user,
} from "../../store/services/authentication";
import { FaRegEye, FaTrashAlt, FaTimes, FaPlus, FaEdit } from "react-icons/fa";
import { asyncStatus } from "../../utils/contants/asyncStatus";

const UserManagment = () => {
  const dispatch = useDispatch();
  const {
    get_users_data,
    get_users_status,
    add_user_status,
    add_user_error,
    update_user_status,
    delete_user_status,
  } = useSelector((state) => state.userAuth);

  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phonenumber: "",
    gender: "Men",
    verified: false,
  });

  useEffect(() => {
    dispatch(get_users());
  }, [dispatch, delete_user_status,update_user_status]);
  // Add this state at the top
  const [formError, setFormError] = useState(null);

  // Update the useEffect for handling success
  useEffect(() => {
    if (
      add_user_status === asyncStatus.SUCCEEDED ||
      update_user_status === asyncStatus.SUCCEEDED
    ) {
      setIsFormModalOpen(false);
      setFormError(null);
      setSelectedUser(null);
      setIsEditMode(false);
    }
  }, [add_user_status, update_user_status]);

  // Modify handleSubmit to use async/await
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError(null);

    try {
      if (isEditMode) {
        await dispatch(
          update_user({
            id: selectedUser._id,
            ...formData,
          })
        ).unwrap();
      } else {
        await dispatch(add_user(formData)).unwrap();
      }
    } catch (error) {
      setFormError(error.message || "An error occurred");
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleAddUser = () => {
    setIsFormModalOpen(true);

    setFormData({
      first_name: "",
      last_name: "",
      email: "",
      phonenumber: "",
      gender: "Men",
      verified: false,
      role: "User",
    });
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    setIsEditMode(true);
    setIsFormModalOpen(true);
    setFormData({
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      phonenumber: user.phonenumber,
      gender: user.gender,
      verified: user.verified,
    });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (isEditMode) {
  //     dispatch(
  //       update_user({
  //         id: selectedUser._id,
  //         ...formData,
  //       })
  //     );
  //   } else {
  //     dispatch(add_user(formData));
  //   }
  // };

  const handleDelete = (userId) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      dispatch(delete_user(userId));
    }
  };

  const handleView = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  if (get_users_status === asyncStatus.LOADING) {
    return <div className="text-center py-8 text-black">Loading users...</div>;
  }

  if (get_users_status === asyncStatus.ERROR) {
    return (
      <div className="text-center py-8 text-red-500">Error loading users</div>
    );
  }

  console.log("add_user_error", add_user_error);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">User Management</h1>
        <button
          onClick={handleAddUser}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
        >
          <FaPlus className="inline-block" />
          Add User
        </button>
      </div>

      {/* Add/Edit User Modal */}
      {isFormModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold text-black">
                {isEditMode ? "Edit User" : "Add New User"}
              </h2>
              <button
                onClick={() => {
                  setIsFormModalOpen(false);
                  setFormError(null);
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes className="h-6 w-6" />
              </button>
            </div>

            {/* Error display */}
            {(formError || add_user_error) && (
              <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg text-sm">
                {formError || add_user_error?.message}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      First Name *
                    </label>
                    <input
                      type="text"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border rounded-lg"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Last Name *
                    </label>
                    <input
                      type="text"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border rounded-lg"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border rounded-lg"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phonenumber"
                    value={formData.phonenumber}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border rounded-lg"
                  />
                </div>
                {!isEditMode && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Password
                    </label>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border rounded-lg"
                    />
                  </div>
                )}

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Gender
                    </label>
                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border rounded-lg"
                    >
                      <option value="Men">Men</option>
                      <option value="Women">Women</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div>
                    <label className="flex items-center space-x-2 mt-6">
                      <input
                        type="checkbox"
                        name="verified"
                        checked={formData.verified}
                        onChange={handleInputChange}
                        className="form-checkbox"
                      />
                      <span className="text-sm text-gray-700">Verified</span>
                    </label>
                  </div>
                </div>

                <div className="mt-6">
                  <button
                    type="submit"
                    className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700"
                  >
                    {isEditMode ? "Update User" : "Add User"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* View User Modal */}
      {isModalOpen && selectedUser && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold text-black">
                {selectedUser.first_name}'s Profile
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes className="h-6 w-6" />
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <img
                    className="h-24 w-24 rounded-full"
                    src={selectedUser.avatar}
                    alt="User avatar"
                  />
                  <div>
                    <h3 className="text-lg font-semibold text-black">
                      {selectedUser.first_name} {selectedUser.last_name}
                    </h3>
                    <p className="text-gray-600">{selectedUser.email}</p>
                    <p className="text-gray-600">{selectedUser.phonenumber}</p>
                  </div>
                </div>

                <div>
                  <h4 className="font-medium mb-2 text-black">
                    Basic Information
                  </h4>
                  <dl className="grid grid-cols-2 gap-2">
                    <div>
                      <dt className="text-sm text-gray-500">Gender</dt>
                      <dd className="text-sm text-gray-500">
                        {selectedUser.gender || "N/A"}
                      </dd>
                    </div>
                    <div>
                      <dt className="text-sm text-gray-500">Zodiac</dt>
                      <dd className="text-sm text-gray-500">
                        {selectedUser.zodiac || "N/A"}
                      </dd>
                    </div>
                    <div>
                      <dt className="text-sm text-gray-500">Education</dt>
                      <dd className="text-sm text-gray-500">
                        {selectedUser.education || "N/A"}
                      </dd>
                    </div>
                    <div>
                      <dt className="text-sm text-gray-500">Family Plans</dt>
                      <dd className="text-sm text-gray-500">
                        {selectedUser.familyPlans || "N/A"}
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <h4 className="font-medium mb-2 text-black">Location</h4>
                  <p className="text-sm text-gray-500">
                    {selectedUser.city}
                    <br />
                    Coordinates: {selectedUser.lattitude},{" "}
                    {selectedUser.longitude}
                  </p>
                </div>

                <div>
                  <h4 className="font-medium mb-2 text-black">Bio</h4>
                  <p className="text-sm whitespace-pre-line text-gray-500">
                    {selectedUser.bio || "No bio available"}
                  </p>
                </div>

                <div>
                  <h4 className="font-medium mb-2 text-black">Preferences</h4>
                  <dl className="grid grid-cols-2 gap-2">
                    <div>
                      <dt className="text-sm text-gray-500">Interested In</dt>
                      <dd className="text-sm text-gray-500">
                        {selectedUser.interest_in || "N/A"}
                      </dd>
                    </div>
                    <div>
                      <dt className="text-sm text-gray-500">
                        Relationship Goals
                      </dt>
                      <dd className="text-sm text-gray-500">
                        {selectedUser.relationshipGoals || "N/A"}
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>

            <div className="mt-4 pt-4 border-t border-gray-200">
              <div className="flex justify-between text-sm text-gray-500">
                <div>
                  Created:{" "}
                  {new Date(selectedUser.createdAt).toLocaleDateString()}
                </div>
                <div>
                  Updated:{" "}
                  {new Date(selectedUser.updatedAt).toLocaleDateString()}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Users Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Location
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Verified
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {get_users_data?.users?.map((user) => (
              <tr key={user._id}>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="flex-shrink-0 h-10 w-10">
                      <img
                        className="h-10 w-10 rounded-full"
                        src={user.avatar}
                        alt={`${user.first_name}'s avatar`}
                      />
                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900">
                        {user.first_name} {user.last_name}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {user.email}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {user.city}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {user.verified ? (
                    <span className="text-green-500">✓</span>
                  ) : (
                    <span className="text-red-500">✕</span>
                  )}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button
                    onClick={() => handleEdit(user)}
                    className="text-yellow-600 hover:text-yellow-800 mr-4"
                    aria-label="Edit user"
                  >
                    <FaEdit className="inline-block" />
                  </button>
                  <button
                    onClick={() => handleView(user)}
                    className="text-indigo-600 hover:text-indigo-900 mr-4"
                    aria-label="View user"
                  >
                    <FaRegEye className="inline-block" />
                  </button>
                  <button
                    onClick={() => handleDelete(user._id)}
                    className="text-red-600 hover:text-red-900"
                    aria-label="Delete user"
                  >
                    <FaTrashAlt className="inline-block" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {get_users_status === asyncStatus.SUCCEEDED &&
          !get_users_data?.users?.length && (
            <div className="text-center py-4 text-gray-500">No users found</div>
          )}
      </div>
    </div>
  );
};

export default UserManagment;
